import React, {useState} from 'react';
import {FaMobileAlt} from 'react-icons/fa';
import Post from './components/Post';
import AuthShell from './components/AuthShell';

const Forgot = () => {
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);

  const forgot = async () => {
    if (!mobile) {
      window.alert('Please Enter Mobile Number');
      return;
    }
    setLoading(true);
    try {
      const res = await Post.Forgot({mobile});
      setLoading(false);
      if (res.id) {
        window.location.href = `/otp?id=${res.id}&type=forgot`;
      } else {
        window.alert(res.errorMsg || 'Error sending OTP');
      }
    } catch (e) {
      setLoading(false);
      window.alert('Error sending OTP');
    }
  };

  return (
    <AuthShell title="Forgot Password?" loading={loading}>
      <form
        className="auth-form"
        onSubmit={event => {
          event.preventDefault();
          forgot();
        }}>
        <label className="auth-field">
          <FaMobileAlt className="auth-field-icon" size={20} />
          <input
            className="auth-input"
            type="tel"
            inputMode="numeric"
            autoComplete="tel"
            maxLength={10}
            placeholder="Mobile Number"
            aria-label="Mobile Number"
            value={mobile}
            onChange={event =>
              setMobile(event.target.value.replace(/[^0-9]/g, ''))
            }
          />
        </label>
        <button className="auth-submit" type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Next'}
        </button>
      </form>
      <div className="auth-footer">
        <span>Remember your password?</span>
        <button
          className="auth-link"
          type="button"
          onClick={() => (window.location.href = '/')}>
          Login
        </button>
      </div>
    </AuthShell>
  );
};

export default Forgot;
